import { render, staticRenderFns } from "./LogoutBtn.vue?vue&type=template&id=22be0090&scoped=true"
import script from "./LogoutBtn.vue?vue&type=script&lang=ts"
export * from "./LogoutBtn.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22be0090",
  null
  
)

export default component.exports